export var isOldGatsbyImage = function isOldGatsbyImage(image) {
  return typeof image !== 'string' && !!image && (!!image.childImageSharp && (!!image.childImageSharp.fixed || !!image.childImageSharp.fluid) || !!image.fixed || !!image.fluid);
};
export var getOldImage = function getOldImage(oldImage) {
  if (!isOldGatsbyImage(oldImage)) {
    throw Error('You must call this method with an old gatsby-image image data');
  }
  return oldImage.childImageSharp ? oldImage.childImageSharp : oldImage;
};
export var isGatsbyImage = function isGatsbyImage(image) {
  return typeof image !== 'string' && !!image && (!!image.childImageSharp && !!image.childImageSharp.gatsbyImageData || !!image.gatsbyImageData);
};
export var isServerSideRendering = function isServerSideRendering() {
  return typeof window === 'undefined';
};